(() => {
  const init = root => {
    root.querySelectorAll('[data-paw-flash-stage]').forEach(stage => {
      if (stage.dataset.flashRailReady) return;
      stage.dataset.flashRailReady = 'true';
      const rail = stage.querySelector('[data-paw-flash-rail]');
      const prev = stage.querySelector('[data-paw-flash-prev]');
      const next = stage.querySelector('[data-paw-flash-next]');
      if (!rail || !prev || !next) return;
      const update = () => {
        const overflow = rail.scrollWidth - rail.clientWidth > 2;
        prev.hidden = !overflow;
        next.hidden = !overflow;
      };
      const move = direction => {
        const end = rail.scrollWidth - rail.clientWidth;
        if (end < 2) return;
        if (direction < 0 && rail.scrollLeft <= 2) { rail.scrollTo({left:end,behavior:'smooth'}); return; }
        if (direction > 0 && rail.scrollLeft >= end - 2) { rail.scrollTo({left:0,behavior:'smooth'}); return; }
        const card = rail.querySelector('.product-card');
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 18;
        const distance = card ? card.getBoundingClientRect().width + gap : 300;
        rail.scrollBy({left:direction * distance * (innerWidth < 750 ? 1 : 2),behavior:'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    });
    root.querySelectorAll('[data-flash-clock]').forEach(clock => {
      if (clock.dataset.flashReady) return;
      clock.dataset.flashReady = 'true';
      const label = clock.querySelector('.paw-flash-clock__label');
      const hours = clock.querySelector('[data-flash-hours]');
      const minutes = clock.querySelector('[data-flash-minutes]');
      const seconds = clock.querySelector('[data-flash-seconds]');
      const mode = clock.dataset.mode;
      const daily = clock.dataset.dailyEnd || '23:59';
      const defaultLabel = clock.dataset.clockLabel || 'Ends In:';
      const fixed = Date.parse(clock.dataset.fixedEnd || '');
      const update = () => {
        if (!clock.isConnected) { window.clearInterval(clock._flashTimer); return; }
        const now = Date.now();
        let end;
        if (mode === 'fixed') {
          if (!Number.isFinite(fixed)) { clock.hidden = true; return; }
          end = fixed;
        } else {
          const parts = /^(\d{1,2}):([0-5]\d)$/.exec(daily);
          const h = parts ? Number(parts[1]) : 23;
          const m = parts ? Number(parts[2]) : 59;
          const ist = new Date(now + 330 * 60000);
          const dayStart = Date.UTC(ist.getUTCFullYear(),ist.getUTCMonth(),ist.getUTCDate());
          end = dayStart + (Math.min(h,23) * 60 + m - 330) * 60000;
          if (end <= now) end += 86400000;
        }
        const remaining = Math.max(0,Math.ceil((end-now)/1000));
        const h = Math.floor(remaining/3600);
        const m = Math.floor(remaining%3600/60);
        const s = remaining%60;
        hours.textContent = String(h).padStart(2,'0') + 'h';
        minutes.textContent = String(m).padStart(2,'0') + 'm';
        seconds.textContent = String(s).padStart(2,'0') + 's';
        label.textContent = mode === 'fixed' && remaining === 0 ? 'Offer ended' : defaultLabel;
        clock.setAttribute('aria-label', remaining === 0 && mode === 'fixed' ? 'Offer ended' : 'Ends in ' + h + ' hours, ' + m + ' minutes and ' + s + ' seconds');
      };
      update();
      clock._flashTimer = window.setInterval(update,1000);
    });
  };
  if (window.pawFlashClockInit) { window.pawFlashClockInit(document); return; }
  window.pawFlashClockInit = init;
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
